import script from "./minor-card.vue?vue&type=script&lang=ts&setup=true"
export * from "./minor-card.vue?vue&type=script&lang=ts&setup=true"

import "./minor-card.vue?vue&type=style&index=0&id=63df024e&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63df024e"]])

export default __exports__